import { WeaponMode, WeaponInformers, WeaponType } from '@/api/types';

export const messages = {
  NOT_FOUND:
    'У вас немає зброї, або ми не знайшли ваші дані в базі. Якщо ви є особою з правом володіти та користуватися зброєю, зверніться до вашого органу НПУ щоб вирішити проблему відображення вашої зброї на сайті.',
};
export const informersText: Record<WeaponInformers, { header: string; text: string }> = {
  HAS_TIME_OUT: {
    header: 'Ви протермінували отримання  дозволу на зберігання та носіння!',
    text: 'Ви не можете замовляти будь-які послуги, що стосуються зброї. Для вирішення проблеми вам необхідно особисто зʼявитися в ваш орган Національної поліції України.',
  },
  HAS_NO_STORAGE_CARRYING: {
    header: 'Не отримано дозвіл на зберігання та носіння!',
    text: `Ви не можете замовляти будь які послуги, що стосуются зброї.
    Для вирішення проблеми вам необхідно особисто з'явитись в ваш орган Національної поліції України.`,
  },
  MIN_AGE_18: {
    header: 'Вам не виповнилось 18 років!',
    text: `Ви не можете замовляти будь які послуги, що стосуются зброї. Для вирішення проблеми вам необхідно
    особисто з'явитись в ваш орган Національної поліції України.`,
  },
};

export const erzStatusName: Record<WeaponMode, string> = {
  [WeaponMode.PERMITTED]: 'Користування зброєю дозволено',
  [WeaponMode.COMMISSION_SALE]: 'Зброю передано на комісійний продаж',
  [WeaponMode.REPAIR]: 'Зброю передано на ремонт',
};
export const erzTypeName: Record<WeaponType, string> = {
  cold_steel: 'Холодна',
  firearm: 'Вогнепальна',
  firearm_part: 'Основні частини',
};
